import { Dialog, TextField } from "@mui/material";
import { useState } from "react";
import DialogContentSelectGeneric from "./DialogsContents/DialogContentGeneric";

export default function SelectTributacao({
    value,
    required = false,
    error = false,
    errorMessage = undefined,
    onChange
}: SelectSimpleApiQueryProps) {

    const [openModal, setOpenModal] = useState(false);

    const handleClose = () => setOpenModal(false);

    const inputLabel = value ? `${value.nome}` : "";

    return (
        <>
            <TextField
                {...{ required, error }}
                label={`Tributação`}
                variant="outlined"
                fullWidth
                onClick={() => setOpenModal(true)}
                onKeyDown={(e) => {
                    if (e.key === "Enter") {
                        setOpenModal(true);
                    }
                }}
                slotProps={{
                    input: { readOnly: true }
                }}
                value={inputLabel}
                helperText={error ? errorMessage : ""}
            />

            {
                openModal &&
                <Dialog
                    fullWidth
                    maxWidth="sm"
                    open={openModal}
                    onClose={handleClose}
                >
                    <DialogContentSelectGeneric
                        {...{ handleClose }}
                        extraParams={{ limit: 50 }}
                        title="Selecionar tributação"
                        queryPath="/fiscal/pesquisar-tributacao"
                        getItemKey={(item) => item.id}
                        getItemLabel={(item) => `${item.nome}`}
                        defaultValue={value || defaultTributacao}
                        onChange={(value) => {
                            onChange(value as IPesquisaTributacao);
                            handleClose();
                        }}
                    />
                </Dialog>
            }
        </>
    );
}

interface SelectSimpleApiQueryProps {
    value: IPesquisaTributacao | null;
    onChange: (arg: IPesquisaTributacao | null) => void;
    required?: boolean;
    error?: boolean;
    errorMessage?: string | undefined;
}

export interface IPesquisaTributacao {
    id: string;
    nome: string;
}

const defaultTributacao: IPesquisaTributacao = {
    id: "",
    nome: ""
};